import { Different } from '@/components/claims/Different';
import { Hero } from '@/components/claims/Hero';
import HowItWorks from '@/components/claims/HowItWorks';
import { Stats } from '@/components/claims/Stats';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import type { Config } from '@/pageConfig/claims';
import dynamic from 'next/dynamic';

const Reviews = dynamic(() => import('@/components/claims/Reviews').then(mod => mod.Reviews));

interface ClaimsPageTemplateProps {
  config: Config;
}

export const ClaimsPageTemplate: React.FC<ClaimsPageTemplateProps> = ({ config }) => {
  return (
    <Layout headerActions={config.layout.headerActions}>
      <SEO {...config.seo} />
      <PageWrapper>
        <Hero {...config.hero} />
        <Stats {...config.stats} />
        <HowItWorks {...config.howItWorks} />
        {'reviews' in config && <Reviews {...config.reviews} />}
        <Different {...config.different} />
      </PageWrapper>
    </Layout>
  );
};
